import { AuthenticationContext, adalFetch, withAdalLogin } from 'react-adal';

export const adalConfig = {
    tenant: 'ba6750d3-d0c9-47c5-b8f6-989c1e0c0312',
    clientId: '81f2378d-f80f-4892-a2f0-09d5f2b38573',
    endpoints: {
        api: '81f2378d-f80f-4892-a2f0-09d5f2b38573'

    },
    // pinned on purpose: with no redirectUri adal falls back to the URL the bundle loaded on (adal.js:161),
    // so a cold load on an inner route (F5, deep link, expired session) sent an unregistered reply URL to AAD
    // and the login died with AADSTS50011. Only the environment roots are registered as reply URLs. Adal stores
    // the starting URL in adal.login.request and navigates back to it after the callback (navigateToLoginRequestUrl)
    redirectUri: window.location.origin + '/',
    postLogoutRedirectUri: window.location.origin,
    cacheLocation: 'localStorage',
    // wait for the silent-renewal iframe before declaring failure (adal default 6s); lower values surface the
    // session modal sooner but declare premature failures on slow networks — the modal self-heals when the late token lands
    loadFrameTimeout: 5000,
};

export const authContext = new AuthenticationContext(adalConfig);

export const adalApiFetch = (fetch, url, options) =>
    adalFetch(authContext, adalConfig.endpoints.api, fetch, url, options);

export const getToken = () => {
        return authContext.getCachedToken(authContext.config.clientId);
}
export const withAdalLoginApi = withAdalLogin(authContext, adalConfig.endpoints.api);